import React, { useState, useEffect } from "react";

import { useHistory, useParams } from "react-router-dom";

import { Box, Button, Flex } from "@chakra-ui/react";

import { Form, Formik } from "formik";
import { FocusError } from "../../../components/FocusError";
import * as Yup from "yup";
import Swal from "sweetalert2";

import { OcorrenciasCadastrar } from "./Cadastrar";
import CriancaService from "../../../../main/services/CriancaService";
import {
  Permission,
  criancaFunc,
  ocorrenciasFunc,
  servicoAcolhimentoFunc,
} from "../../../../helpers/Funcionalidades";
import { VisualizarPageOcorrencias } from "./Visualizar";
import SemRegistros from "../../../components/SemRegistros";
import { isAfter, isValid, parse } from "date-fns";
import { useAppContext } from "../../../../Context/MessageContextProvider";
import { hasFormChanged } from "../../../utils/hasFormChanged";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import { useAuth } from "react-oidc-context";

const schema = Yup.object().shape({
  dataOcorrencia: Yup.string("Este campo é obrigatório!")
    .nullable()
    .required("Este campo é obrigatório!")
    .test("validDate", "Data inválida!", (value) => {
      if (!!value) {
        if (value.length === 10) {
          return isValid(parse(value, "dd/MM/yyyy", new Date()));
        } else {
          return false;
        }
      } else {
        return false;
      }
    })
    .test(
      "dataNascimentoAfterToday",
      "A data informada não pode ser uma data futura!",
      (value) => {
        if (!value) {
          return true;
        } else {
          return !isAfter(parse(value, "dd/MM/yyyy", new Date()), new Date());
        }
      }
    ),
  tipoOcorrencia: Yup.object().nullable().required("Este campo é obrigatório!"),
  justificativaOcorrencia: Yup.string()
    .trim()
    .when("tipoOcorrencia.id", {
      is: 5,
      then: Yup.string().required("Este campo é obrigatório!"),
      otherwise: Yup.string(),
    }),
});

export const VisualizarOcorrencias = ({ setLoadingPainel }) => {
  const { id, idOrgaoExterno } = useParams();
  const [isTrueVisualizar, setIsTrueVisualizar] = useState(true);
  const history = useHistory();
  const url = window.location.href;
  const keycloak = useAuth();
  const {
    setEditarOcorCrianca,
    setCadastrarOcorCrianca,
    cadastrarOcorrencia,
    setCadastrarOcorrencia,
    atualizarOcorrencia,
    setAtualizarOcorrencia,
    possuiOcorrencia,
    setEditarCriancaCr,
  } = useAppContext();
  const { roleKeycloack, user } = useAuthProvider();
  const { idPJ } = useAppContext();
  const [initialValues, setInitialValues] = useState({
    idOcorrencia: "",
    dataOcorrencia: "",
    descricaoOcorrencia: "",
    tipoOcorrencia: "",
    justificativaOcorrencia: "",
    tipoSearch: "",
    dataSearch1: "",
    dataSearch2: "",
  });

  useEffect(() => {
    setEditarCriancaCr(false);
  }, [setEditarCriancaCr]);

  useEffect(() => {
    if (url.includes("visualizar")) {
      setIsTrueVisualizar(true);
      setInitialValues({
        idOcorrencia: "",
        dataOcorrencia: "",
        descricaoOcorrencia: "",
        tipoOcorrencia: "",
        justificativaOcorrencia: "",
        tipoSearch: "",
        dataSearch1: "",
        dataSearch2: "",
      });
      setCadastrarOcorCrianca(false);
      setEditarOcorCrianca(false);
    }
  }, [url, setCadastrarOcorCrianca, setEditarOcorCrianca]);

  const onKeyDown = (keyEvent) => {
    if (keyEvent.code === "Enter" || keyEvent.code === "NumpadEnter") {
      keyEvent.preventDefault();
    }
  };

  useEffect(() => {
    if (atualizarOcorrencia) {
      Swal.fire({
        title: "Sucesso!",
        text: "Registro atualizado com sucesso!",
        icon: "success",
        confirmButtonText: "Continuar",
        confirmButtonColor: "#169499",
      }).then((result) => {
        setAtualizarOcorrencia(false);
      });
    } else if (cadastrarOcorrencia) {
      Swal.fire({
        title: "Sucesso!",
        text: "Registro cadastrado com sucesso!",
        icon: "success",
        confirmButtonText: "Continuar",
        confirmButtonColor: "#169499",
      }).then((result) => {
        setCadastrarOcorrencia(false);
      });
    }
  }, [
    atualizarOcorrencia,
    setAtualizarOcorrencia,
    cadastrarOcorrencia,
    setCadastrarOcorrencia,
  ]);

  const handleSubmit = (values, actions) => {
    setTimeout(() => {
      const {
        dataOcorrencia,
        descricaoOcorrencia,
        tipoOcorrencia,
        justificativaOcorrencia,
        idOcorrencia,
      } = values;

      const dataOcorrenciaObj = parse(dataOcorrencia, "dd/MM/yyyy", new Date());

      const horaAtual = new Date();
      const diferencaFusoHorario = dataOcorrenciaObj.getTimezoneOffset() / 60;
      dataOcorrenciaObj.setHours(
        horaAtual.getHours() - diferencaFusoHorario,
        horaAtual.getMinutes(),
        horaAtual.getSeconds()
      );

      const valuesToSend = {
        dataOcorrencia: dataOcorrencia ? dataOcorrenciaObj.toISOString() : "",
        descricaoOcorrencia:
          descricaoOcorrencia && tipoOcorrencia.id !== 5
            ? descricaoOcorrencia
            : "",
        idTipoOcorrencia: tipoOcorrencia.id,
        justificativaOcorrencia:
          justificativaOcorrencia && tipoOcorrencia.id === 5
            ? justificativaOcorrencia
            : "",
        nomeResponsavelOcorrencia: keycloak?.user.profile?.name,
      };

      if (url.includes("editar")) {
        CriancaService.putOcorrencias(id, valuesToSend, idOcorrencia)
          .then((res) => {
            setIsTrueVisualizar(!isTrueVisualizar);
            setEditarOcorCrianca(false);
            setCadastrarOcorCrianca(false);
            history.push(`/crianca/visualizar-ocorrencias/${id}`);
            setAtualizarOcorrencia(true);
          })
          .catch((error) => {
            console.log(error.response.data);
            Swal.fire({
              title: "Atenção!",
              text: error.response.data.message
                ? error.response.data.message
                : "",
              icon: "error",
              confirmButtonText: "Fechar",
              confirmButtonColor: "#169499",
            });
          });
      } else if (url.includes("cadastrar")) {
        CriancaService.postOcorrencias(id, valuesToSend)
          .then((res) => {
            setIsTrueVisualizar(true);
            setEditarOcorCrianca(false);
            setCadastrarOcorCrianca(false);
            history.push(`/crianca/visualizar-ocorrencias/${id}`);
            setCadastrarOcorrencia(true);
          })
          .catch((error) => {
            console.log(error.response.data);
            Swal.fire({
              title: "Atenção!",
              text: error.response.data.message
                ? error.response.data.message
                : "",
              icon: "error",
              confirmButtonText: "Fechar",
              confirmButtonColor: "#169499",
            });
          });
      }

      actions.setSubmitting(false);
    });
  };

  return (
    <>
      <Flex flex={1} flexDir="column" alignItems="center" overflow="auto">
        <Flex flexDir="column" w="100%">
          <Formik
            validationSchema={schema}
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validateOnChange={false}
            validateOnBlur={false}
            enableReinitialize
          >
            {(props) => (
              <Form onKeyDown={onKeyDown}>
                {url.includes("editar") &&
                  setEditarOcorCrianca(
                    hasFormChanged(initialValues, props.values)
                  )}

                <FocusError />
                {url.includes("visualizar") ? (
                  roleKeycloack &&
                  (roleKeycloack?.includes(ocorrenciasFunc.visualizar) ||
                    ((roleKeycloack?.includes(
                      criancaFunc.visualizarTudoAcolhimento
                    ) ||
                      roleKeycloack?.includes(
                        criancaFunc.visualizarTudoTutelar
                      )) &&
                      user?.orgaoExterno?.includes(idPJ))) ? (
                    <VisualizarPageOcorrencias
                      id={id}
                      setIsTrueVisualizar={setIsTrueVisualizar}
                      props={props}
                      setInitialValues={setInitialValues}
                      setLoadingPainel={setLoadingPainel}
                      user={user}
                      idPJ={idPJ}
                    />
                  ) : (
                    <Box mt="2">
                      <SemRegistros buttonVisible={true} />
                    </Box>
                  )
                ) : roleKeycloack &&
                  (roleKeycloack?.includes(
                    url.includes("cadastrar")
                      ? ocorrenciasFunc.incluir
                      : url.includes("editar")
                      ? ocorrenciasFunc.alterar
                      : ""
                  ) ||
                    ((roleKeycloack?.includes(
                      criancaFunc.visualizarTudoAcolhimento
                    ) ||
                      roleKeycloack?.includes(
                        criancaFunc.visualizarTudoTutelar
                      ) ||
                      roleKeycloack?.includes(
                        servicoAcolhimentoFunc.visualizarParteTJ
                      ) ||
                      roleKeycloack?.includes(
                        servicoAcolhimentoFunc.visualizarParteMP
                      ) ||
                      roleKeycloack?.includes(
                        servicoAcolhimentoFunc.visualizarPartePPCAAM
                      )) &&
                      (user?.orgaoExterno?.includes(idPJ) ||
                        user?.orgaoExterno?.includes(
                          Number(idOrgaoExterno) ||
                            user?.orgaoExterno?.includes(Number(idOrgaoExterno))
                        ) ||
                        user?.orgaos[0]?.id === Number(idOrgaoExterno)))) ? (
                  <OcorrenciasCadastrar
                    initialValues={initialValues}
                    valuesProps={props.values}
                    setInitialValues={setInitialValues}
                  />
                ) : (
                  <Box mt="2">
                    <SemRegistros buttonVisible={true} />
                  </Box>
                )}
                <Flex justifyContent="flex-end" gap={4}>
                  {(url.includes("cadastrar") || url.includes("editar")) &&
                    !possuiOcorrencia && (
                      <Button
                        mt="30px"
                        px="45px"
                        h="42px"
                        color="#FFF"
                        backgroundColor="#169499"
                        fontWeight={700}
                        fontSize="15px"
                        lineHeight="21.6px"
                        onClick={() =>
                          history.push(`/crianca/visualizar-ocorrencias/${id}`)
                        }
                        _hover={{ bg: "#169499" }}
                      >
                        {"Cancelar"}
                      </Button>
                    )}

                  <Permission
                    roleKeycloack={roleKeycloack}
                    func={
                      url.includes("cadastrar")
                        ? ocorrenciasFunc.incluir
                        : url.includes("editar")
                        ? ocorrenciasFunc.alterar
                        : ""
                    }
                    user={user}
                    id={idPJ}
                    visualizar={true}
                    mpTJ={url.includes("editar") ? true : false}
                    idMPTJ={idOrgaoExterno && Number(idOrgaoExterno)}
                    ppcaam={url.includes("editar") ? true : false}
                  >
                    {url.includes("cadastrar") || url.includes("editar") ? (
                      <Button
                        type="submit"
                        translate="no"
                        mt="30px"
                        px="45px"
                        h="42px"
                        color="#FFF"
                        backgroundColor="#169499"
                        fontWeight={700}
                        fontSize="15px"
                        lineHeight="21.6px"
                        _hover={{ bg: "#169499" }}
                        isLoading={props.isSubmitting}
                      >
                        {"Salvar"}
                      </Button>
                    ) : (
                      ""
                    )}
                  </Permission>
                </Flex>
              </Form>
            )}
          </Formik>
        </Flex>
      </Flex>
    </>
  );
};
